import { UploadFileOutlined } from '@mui/icons-material';
import { Stack } from '@mui/material';
import { FieldProps } from 'formik';
import { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';

import { FileDropzoneChip, FileDropzoneContainer, FileDropzoneLabel } from '@styles/InputStyles';

interface IFileDropzoneProps extends FieldProps {
  id?: string;
  displayText?: string;
  name: string;
  onFileChange?: (name: string, acceptedFiles: File[]) => void;
}

export const FileDropzone = ({
  displayText = 'Drag & drop files here',
  form,
  field,
  onFileChange,
}: IFileDropzoneProps) => {
  const onDrop = useCallback(
    (acceptedFiles: File[]) => {
      if (onFileChange) {
        onFileChange(field.name, acceptedFiles);
      } else {
        form.setFieldValue(field.name, acceptedFiles);
      }
    },
    [form.values],
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });
  return (
    <FileDropzoneContainer {...getRootProps({ className: 'dropzone' })}>
      <input {...getInputProps()} />

      <UploadFileOutlined fontSize="large" />

      <Stack spacing={2}>
        <FileDropzoneLabel>{isDragActive ? 'Drop the files here ...' : displayText}</FileDropzoneLabel>

        {!isDragActive && <FileDropzoneLabel>Or</FileDropzoneLabel>}

        {!isDragActive && (
          <FileDropzoneChip label="Browse Files"/>
        )}
      </Stack>
    </FileDropzoneContainer>
  );
};
